module.exports = __webpack_public_path__ + "img/nyi-home.991e7153.jpg";